'use strict';

var authMethods = ['google', 'facebook', 'github', 'twitter', 'linkedin', 'email', 'sms'];
var signInMethods = authMethods;

module.exports = signInMethods;
//# sourceMappingURL=authMethods.js.map
